__turbopack_context__.v({
  "body": "MyShows-module-scss-module__q9DuBq__body",
  "connect-button": "MyShows-module-scss-module__q9DuBq__connect-button",
  "content": "MyShows-module-scss-module__q9DuBq__content",
  "header": "MyShows-module-scss-module__q9DuBq__header",
  "loading": "MyShows-module-scss-module__q9DuBq__loading",
  "modal": "MyShows-module-scss-module__q9DuBq__modal",
  "no-show-description": "MyShows-module-scss-module__q9DuBq__no-show-description",
  "no-show-image": "MyShows-module-scss-module__q9DuBq__no-show-image",
  "no-show-state": "MyShows-module-scss-module__q9DuBq__no-show-state",
  "no-show-title": "MyShows-module-scss-module__q9DuBq__no-show-title",
  "no-show-wrapper": "MyShows-module-scss-module__q9DuBq__no-show-wrapper",
  "show-details": "MyShows-module-scss-module__q9DuBq__show-details",
  "show-info": "MyShows-module-scss-module__q9DuBq__show-info",
  "show-item": "MyShows-module-scss-module__q9DuBq__show-item",
  "show-name": "MyShows-module-scss-module__q9DuBq__show-name",
  "shows-list": "MyShows-module-scss-module__q9DuBq__shows-list",
  "title": "MyShows-module-scss-module__q9DuBq__title",
});
